export default __webpack_public_path__ + "static/media/gitbook.a39036de.svg";